const getReferralId = (enrollmentId: string, siteCode: string): string =>
  `${enrollmentId}_${siteCode}`;

export default getReferralId;
